import { createVimeoEmbedUrl } from '../../../mission/scenes/missionSelected/ActiveMission/SteppedQuestion/VideoEmbedQuestionStep/logic';

export const getPlayerSources = (sources, isDesktop) => {
  if (sources?.vimeoEmbedId) {
    return createVimeoEmbedUrl(sources?.vimeoEmbedId);
  }
  return null;
};
